import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from './PageTitle.css'

const propTypes = {
    children: PropTypes.node.isRequired,
    type: PropTypes.oneOf(['large', 'small']),
    tooltipId: PropTypes.string,
}

const defaultProps = {
    type: 'large',
}


const PageTitle = (props) => {
    const classNameBase = classNames(styles.base, styles[`base__${props.type}`])

    const dataAttrs = props.tooltipId ? {
        'data-tip': true,
        'data-for': props.tooltipId,
    } : {}

    return (
        <div className={classNameBase} {...dataAttrs}>{props.children}</div>
    )
}

PageTitle.propTypes = propTypes
PageTitle.defaultProps = defaultProps

export default PageTitle



// WEBPACK FOOTER //
// ../node_modules/react-mt-bootstrap/lib/components/PageTitle/PageTitle.jsx